const Style = ({ attributes, clientId }) => {
	const { slides, layout } = attributes;
	const { width, height, align } = layout;

	const mainSl = `#evssSlider-${clientId}`;
	const sliderSl = `${mainSl} .evssSlider`;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${mainSl}{
			text-align: ${align.desktop};
		}

		${sliderSl}{
			width: ${width.desktop};
			height: ${height.desktop};
		}

		@media (min-width: 481px) and (max-width: 768px) {
			${mainSl}{
				text-align: ${align.tablet};
			}
			${sliderSl}{
				width: ${width.tablet};
				height: ${height.tablet};
			}
		}
		
		@media (max-width: 480px) {
			${mainSl}{
				text-align: ${align.mobile};
			}
			${sliderSl}{
				width: ${width.mobile};
				height: ${height.mobile};
			}
		}

		${slides.map((slide, index) => {
			const { background } = slide;

			const slideSl = `${sliderSl} .slide${index + 1}`;

			return `
				${slideSl}{
					${background}
				}
			`;
		}).join('')}
	`}} />;
}
export default Style;